import React from "react";
import { getField } from "../util/DynamicItemUtils";

import PageNode from "./ContentTypeComponents/PageNode";
import EnforcementDocument from "./ContentTypeComponents/EnforcementDocument";
import InspectionReport from "./ContentTypeComponents/InspectionReport";
import NewsRelease from "./ContentTypeComponents/NewsRelease";
import OtherUpdate from "./ContentTypeComponents/OtherUpdate";
import Document from "./ContentTypeComponents/Document";
import DeniedIssuerAuditClient from "./ContentTypeComponents/DeniedIssuerAuditClient";
import SupportingDocumentation from "./ContentTypeComponents/SupportingDocumentation";
import GlobalNetworkFirm from "./ContentTypeComponents/GlobalNetworkFirm";
import StandardsAndInterpretations from "./ContentTypeComponents/StandardsAndInterpretations";
import PcaobOperationsDocument from "./ContentTypeComponents/PcaobOperationsDocument";
import SpeechAndStatement from "./ContentTypeComponents/SpeechAndStatement";
import RulemakingDocket from "./ContentTypeComponents/RulemakingDocket";
import GlobalNetwork from "./ContentTypeComponents/GlobalNetwork";
import PcaobEvent from "./ContentTypeComponents/PcaobEvent";
import Biography from "./ContentTypeComponents/Biography";
import DefaultItem from "./ContentTypeComponents/Default";
import { ResultItemProps, TrackingEvent, useHawkSearch } from 'react-hawksearch';

function ContentTypeDynamicItem({ item, toggle }: any) {

    const {
        store: { searchResults },
    } = useHawkSearch();

    let dynamicItem;
    switch (getField(item, "contenttype")) {
        case "Telerik.Sitefinity.Pages.Model.PageNode":
            dynamicItem = <PageNode item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.EnforcementDocuments.EnforcementDocument":
            dynamicItem = <EnforcementDocument item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.InspectionReports.InspectionReport":
            dynamicItem = <InspectionReport item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.NewsReleases.NewsRelease":
            dynamicItem = <NewsRelease item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.OtherUpdates.OtherUpdate":
            dynamicItem = <OtherUpdate item={item} />;
            break;

        case "Telerik.Sitefinity.Libraries.Model.Document":
            dynamicItem = <Document item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.DeniedIssuerAuditClients.DeniedIssuerAuditClient":
            dynamicItem = <DeniedIssuerAuditClient item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.SupportingDocumentation.SupportingDocumentation":
            dynamicItem = <SupportingDocumentation item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.GlobalNetworkFirms.GlobalNetworkFirm":
            dynamicItem = <GlobalNetworkFirm item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.StandardsAndInterpretations.StandardsAndInterpretations":
            dynamicItem = <StandardsAndInterpretations item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.PcaobOperationsDocuments.PcaobOperationsDocument":
            dynamicItem = <PcaobOperationsDocument item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.SpeechAndStatement.SpeechAndStatement":
            dynamicItem = <SpeechAndStatement item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.RulemakingDocket.RulemakingDocket":
            dynamicItem = <RulemakingDocket item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.GlobalNetworks.GlobalNetwork":
            dynamicItem = <GlobalNetwork item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.PcaobEvents.PcaobEvent":
            dynamicItem = <PcaobEvent item={item} />;
            break;

        case "Telerik.Sitefinity.DynamicTypes.Model.Biography.Biography":
            dynamicItem = <Biography item={item} />;
            break;

        default:
            dynamicItem = <DefaultItem item={item} toggle={toggle} />;
            break;
    }

    const pageurl = window.location.href;
    const isAuditorSearchPage = pageurl.includes("/auditorsearch/") && !pageurl.includes("filingid=");
    const isFormAPFilePage = pageurl.includes("filingid=");

    return (
        <div className={`sf-search-results media-list${isAuditorSearchPage ? ' hawk-results-item' : ''}${isFormAPFilePage ? ' no-bar' : ''}`} onClick={e => {
            TrackingEvent.track('click', {
                event: e,
                uniqueId: item.DocId,
                trackingId: searchResults.TrackingId
            });
        }}>
            <div className="media-body sf-media-body">{dynamicItem}</div>
        </div>
    );
}

export default ContentTypeDynamicItem;
